// Swiper JS
import Swiper, { Navigation, Autoplay, Pagination } from "swiper"

function initSwiper(event) {
    // Ersetzen Sie 'your-slider-class' mit der entsprechenden Klasse für Ihre Slider-Elemente
    const sliderElements = document.querySelectorAll('.custom-swiper');

    sliderElements.forEach((element) => {
        const options = JSON.parse(element.dataset.swiperOptions.replaceAll("'", ""));
        let backendOptions = {};

        if (element.dataset.backend) {
            backendOptions = {
                autoplay: false,
                grabCursor: false,
                draggable: false,
                allowTouchMove: false,
            }
        }

        const swiper = new Swiper(element, {
            modules: [Navigation, Autoplay, Pagination],
            ...options,
            ...backendOptions
        });
    });
}

window.addEventListener("load", initSwiper, {passive: true});
